import { PropsWithChildren, useEffect, useMemo } from 'react'
import { i18n } from '@lingui/core'
import { I18nProvider } from '@lingui/react'
import { activateLingui, defaultLanguage, normalizeLanguage } from '@/i18n'
import { useAppSelector } from '@/redux/rootReducer'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'

export function LanguageProvider({ children }: PropsWithChildren<{}>) {
  const authUser = useAppSelector(selectAuthUser)

  const language = useMemo(
    () => normalizeLanguage(authUser?.userInfo?.language ?? defaultLanguage),
    [authUser],
  )

  useEffect(() => {
    void activateLingui(language)
    document.documentElement.lang = language
  }, [language])

  return (
    <I18nProvider i18n={i18n} defaultComponent={DefaultComponent}>
      {children}
    </I18nProvider>
  )
}

function DefaultComponent({ children }: PropsWithChildren<{}>) {
  return <div>{children}</div>
}
